import { render, staticRenderFns } from "./ot-edit-project-details.vue?vue&type=template&id=1a2e1256&scoped=true&"
import script from "./ot-edit-project-details.vue?vue&type=script&lang=ts&"
export * from "./ot-edit-project-details.vue?vue&type=script&lang=ts&"
import style0 from "./ot-edit-project-details.vue?vue&type=style&index=0&id=1a2e1256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2e1256",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VDivider,VForm,VOverlay})
